<template>
	<div class="page">
		<div class="">
			<div class="main_left">
				<el-image style="width: 5.0625rem;height: 1.5625rem;"
					:src="data.CompanyLogo" fit="fill"></el-image>
				<p>{{data.ProductName}}</p>
				<div class="main_left_info">
					<div class="">
						<p>保障天数</p>
						<p>{{form.DayRange}}</p>
					</div>

					<div class="">
						<p>份数</p>
						<p>{{Object.keys(formDataList).length}}份</p>
					</div>
				</div>

				<div class="main_left_price">
					<p>合计</p>
					<p>￥<span>{{price}}</span></p>
				</div>
			</div>
			<div class="main_right">
				<el-alert title="为了保障您的权益，请填写真实有效的信息。您填写的内容仅供投保使用，对于您的信息我们会严格保密。" type="warning" :closable="false"
					show-icon>
				</el-alert>
				<div class="info">


					<el-form label-position="top" label-width="390px" :model="form" :rules="Rules"
						:validate-on-rule-change="false" ref="infoRef">
						<div class="">
							<div class="info_tiele">
								基本信息
							</div>
							<div style="clear:both;margin-bottom: 0.9375rem;"></div>
							<el-row :gutter="20">
								<el-col :span="12">
									<el-form-item>
										<div solt="label" class="item_label"><span>*</span>选择投保人 <span>(默认投保人为自己)</span>
										</div>
										<el-select style="width: 100%;" v-model="form.applicant" placeholder="请选择">
											<el-option v-for="(item,index) in columns1" :key="index" :label="item.label"
												:value="item.value">
											</el-option>
										</el-select>
									</el-form-item>
								</el-col>

								<el-col :span="12">
									<el-form-item label="起保日期" prop="currentDate">
										<el-date-picker style="width: 100%;" v-model="form.currentDate" type="date"
											placeholder="选择日期" :picker-options="expireTimeOPtion"
											value-format="yyyy-MM-dd">
										</el-date-picker>
									</el-form-item>
								</el-col>
							</el-row>

							<el-row :gutter="20">
								<el-col :span="12">
									<el-form-item label="保障天数" prop="DayRange">
										<el-select disabled style="width: 100%;" v-model="form.DayRange"
											placeholder="请选择">
											<el-option v-for="(item,index) in columns4" :key="index" :label="item"
												:value="item">
											</el-option>
										</el-select>
									</el-form-item>
								</el-col>

								<el-col :span="12">
									<el-form-item prop="destination">
										<div solt="label" class="item_label">
											<span>*</span>旅行目的地 <span>(如有多个国家，选择一个即可)</span>
										</div>
										<el-select style="width: 100%;" multiple v-model="form.destination"
											placeholder="请选择">
											<el-option v-for="(item,index) in columns2" :key="index" :label="item"
												:value="item">
											</el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>

							<el-row :gutter="20">
								<el-col :span="12">
									<el-form-item prop="email">
										<div solt="label" class="item_label">
											<span>*</span>邮箱 <span>(投保成功后，电子保单将发送至邮箱)</span>
										</div>
										<el-input v-model="form.email" placeholder="请输入"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
						</div>

						<div class="" v-if="form.applicant == 2">
							<div class="info_tiele" style="margin-top: 1.25rem;">
								投保人信息
							</div>
							<div style="clear:both;margin-bottom: 0.9375rem;"></div>

							<el-row :gutter="20">
								<el-col :span="12">
									<el-form-item label="企业名称" prop="enterpriseName">
										<el-input v-model="form.enterpriseName" placeholder="请输入" name="enterpriseName"
											@blur="blurInput"></el-input>
									</el-form-item>
								</el-col>

								<el-col :span="12">
									<el-form-item label="企业名称拼音" prop="enterprisePing">
										<el-input v-model="form.enterprisePing" placeholder="请输入"></el-input>
									</el-form-item>
								</el-col>
							</el-row>

							<el-row :gutter="20">
								<el-col :span="12">
									<el-form-item label="统一社会信用代码" prop="enterpriseNumber">
										<el-input v-model="form.enterpriseNumber" placeholder="请输入"></el-input>
									</el-form-item>
								</el-col>

								<el-col :span="12">
									<el-form-item label="手机号码" prop="enterprisePhone">
										<el-input v-model="form.enterprisePhone" placeholder="请输入"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
						</div>
					</el-form>

					<div class="">
						<div class="info_tiele" style="margin-top: 1.25rem;">
							被保人信息({{Object.keys(formDataList).length}}/200人)
						</div>
						<div style="clear:both;margin-bottom: 0.9375rem;"></div>

						<div class="tabs_head">
							<div class="">
								姓名
							</div>
							<div class="">
								姓名拼音
							</div>
							<div class="">
								证件类型
							</div>
							<div class="">
								证件号码
							</div>
							<div class="">
								性别
							</div>
							<div class="">
								出生日期
							</div>
						</div>

						<div class="formData_list">
							<div class="list_item" v-for="(item,index) in formDataList" :key="index">
								<el-form label-position="top" label-width="390px" :model="formDataList[index]"
									:rules="Rules" :validate-on-rule-change="false" :ref="'listRef' + index">
									<span style="padding: 0 0.625rem;">
										{{item.index}}
									</span>
									<!-- 姓名 -->
									<div class="">
										<el-form-item prop="InsuredName">
											<el-input v-model="item.InsuredName" placeholder="请输入" name="InsuredName"
												@blur="blurInput($event,index)"></el-input>
										</el-form-item>
									</div>

									<!-- 姓名拼音 -->
									<div class="">
										<el-form-item prop="InsuredPing">
											<el-input v-model="item.InsuredPing" placeholder="请输入"></el-input>
										</el-form-item>
									</div>

									<!-- 证件类型 -->
									<div class="">
										<el-form-item prop="InsuredType">
											<el-select v-model="item.InsuredType" placeholder="请选择">
												<el-option v-for="(item,index) in columns5" :key="index"
													:label="item.label" :value="item.value">
												</el-option>
											</el-select>
										</el-form-item>
									</div>

									<!-- 证件号码 -->
									<div class="">
										<!-- 身份证 -->
										<el-form-item prop="InsuredIdCard" v-if="item.InsuredType == 1 || item.InsuredType == 0">
											<el-input v-model="item.InsuredIdCard" placeholder="请输入"
												@input="CardInput" @focus="focus(index)">
											</el-input>
										</el-form-item>

										<!-- 护照 -->
										<el-form-item prop="InsuredIdCard2"  v-if="item.InsuredType == 2">
											<el-input v-model="item.InsuredIdCard2" placeholder="请输入"
												@input="CardInput" @focus="focus(index)">
											</el-input>
										</el-form-item>
									</div>

									<!-- 性别 -->
									<div class="">
										<el-form-item prop="InsuredSex">
											<el-select v-model="item.InsuredSex" placeholder="请选择">
												<el-option v-for="(item,index) in columns6" :key="index"
													:label="item.label" :value="item.value">
												</el-option>
											</el-select>
										</el-form-item>
									</div>

									<!-- 出生日期 -->
									<div class="">
										<el-form-item prop="InsuredBirthday">
											<el-date-picker style="width: 100%;" v-model="item.InsuredBirthday"
												type="date" placeholder="选择日期" :picker-options="expireTimeOPtion2"
												:clearable="false" value-format="yyyy-MM-dd">
											</el-date-picker>
										</el-form-item>
									</div>
								</el-form>
							</div>

							<div class="btn_box" style="">
								<el-button class="add_insured" @click="addInsuredForm" type="primary" plain round>
									添加被保人
								</el-button>
							</div>
						</div>

						<div class="footer">
							<div class="">
								<el-checkbox v-model="checked"></el-checkbox>
								我已确认并同意<span>《保险条款》</span>和<span style="cursor:pointer;"
									@click="dialogVisible = true">《投保人申明》</span>
							</div>
							<el-button type="primary" @click="submit">提交
							</el-button>
						</div>
					</div>



				</div>
			</div>
		</div>

		<el-dialog class="dialog_box" title="投保人声明" :visible.sync="dialogVisible" width="47.625rem">
			<p>尊敬的客户：</p>
			<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;感谢您委托我公司代为办理保险业务。本公司是基于投保人利益，为投保人
				与保险公司订立保险合同提供中介服务的保险专业中介机构。为了保护您的合法
				权益，按照《保险经纪人监管管理规定》的要求，本公司应履行客户告知义务，
				现将有关事项告知如下，请仔细阅读。</p>
			<p>一、公司基本情况</p>
			<p>（一）名称：五洲（北京）保险经纪有限公司</p>
			<p>（二）住所：北京市东城区前门东大街23号I2座</p>
			<p>（三）许可证名称及编号：经营保险经纪业务许可证编号：260446000000800</p>
			<p>（四）业务范围：在全国区域内（港、澳、台除外）为投保人拟订投保方案、
				选择保险人、办理投保手续；协助被保险人或受益人进行索赔；再保险经纪业务；
				为委托人提供防灾、防损或风险评估、风险管理咨询服务；中国银保监会批准的
				其它业务</p>
			<p>（五）信息披露查询网址：http://www.chinacib.com/class/view?id=157</p>
			<p>（六）经营区域：全国（港、澳、台除外）</p>
			<p>（七）联系方式：010-85558455</p>
			<p>二、请仔细阅读保险条款。请重点关注保险责任、责任免除或者除外责任、犹豫期后解除合同的损失、投保人和被保险人权利义务、免赔额或免赔率的计算、等待期等内容，并可要求本公司服务人员对上述内容进行详细讲解。</p>
			<p>三、请向本公司客服人员了解《中华人民共和国保险法》等法律法规对于索赔时效、保险公司理赔时限、合同中止与失效、未成年人投保限额等的相关规定，以及不履行如实告知义务、故意制造保险事故或夸大事故损失、申报年龄或职业
				不真实等情形导致的法律后果。</p>
			<p>四、根据《中华人民共和国民法典》的规定，保险经纪机构因过错给投保人、被保险人造成损失的，依法承担赔偿责任。</p>
			<p>五、本公司已按《保险经纪人监管规定》缴存保证金/投保职业责任保险。</p>
			<p>六、本公司及公司高级管理人员与经纪业务相关的保险公司、其它中介机构不存在关联关系。</p>
			<p>七、如果您发现本公司服务人员存在误导行为及其它损害您合法权益的行
				为，请注意保留书面证据或其它证据，可向本公司投诉（电话：010-85558455）</p>
			<p style="text-align: right;">五洲（北京）保险经纪有限公司</p>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false" type="primary">我知道了</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	const util = require('../../util.js')



	export default {
		data() {


			return {
				dialogVisible: false,
				checked: false, // 同意
				Rules: {
					currentDate: [{
						required: true,
						message: '日期不能为空',
						trigger: 'blur'
					}],
					destination: [{
						required: true,
						message: '目的地不能为空',
						trigger: 'blur'
					}],
					email: [{
						required: true,
						message: '邮箱不能为空',
						trigger: 'blur'
					}, {
						trigger: 'blur',
						validator: this.checkEmail
					}],
					DayRange: [{
						required: true,
						message: '天数不能为空',
						trigger: 'blur'
					}],
					enterpriseName: [{
						required: true,
						message: '名称不能为空',
						trigger: 'blur'
					}],
					enterprisePing: [{
						required: true,
						message: '名称拼音不能为空',
						trigger: 'blur'
					}],
					enterpriseNumber: [{
						required: true,
						message: '信用代码不能为空',
						trigger: 'blur'
					}],
					enterprisePhone: [{
						required: true,
						message: '手机号不能为空',
						trigger: 'blur'
					}, {
						validator: this.checkPhone,
						trigger: 'blur'
					}],
					InsuredName: [{
						required: true,
						message: '姓名不能为空',
						trigger: 'blur'
					}],
					InsuredIdCard: [{
						required: true,
						message: '证件号码不能为空',
						trigger: 'blur'
					}, {
						validator: this.checkID,
						trigger: 'blur'
					}],
					InsuredIdCard2: [{
						required: true,
						message: '证件号码不能为空',
						trigger: 'blur'
					}],
					InsuredType: [{
						required: true,
						message: '证件类型不能为空',
						trigger: 'blur'
					}],
					InsuredPing: [{
						required: true,
						message: '姓名拼音不能为空',
						trigger: 'blur'
					}],
					InsuredBirthday: [{
						required: true,
						message: '出生日期不能为空',
						trigger: 'blur'
					}],
					InsuredSex: [{
						required: true,
						message: '性别不能为空',
						trigger: 'blur'
					}]
				},
				data: {},
				form: {
					applicant: 1, //投保人
					email: '', //邮箱
					DayRange: '1-7天', //保障天数
					currentDate: '', //起保日期
					endTime: '', //终保日期
					destination: '', // 旅行目的地
					enterpriseName: '', // 企业名称
					enterprisePing: '', // 企业名称拼音
					enterpriseNumber: '', // 统一社会信用代码
					enterprisePhone: '', // 企业投保人手机号
				},
				productId: '',
				RateCode: '',
				PlanRatePriceId: '',
				price: '',
				tian: '',

				columns1: [{
					label: '默认投保人',
					value: 1
				}, {
					label: '指定投保人',
					value: 2
				}], //投保人数组
				columns2: [], // 国家列表
				columns4: [], // 天数范围
				columns5: [{
					label: '身份证',
					value: 1,
				}, {
					label: '护照',
					value: 2,
				}],

				columns6: [{
					label: '男',
					value: 1,
				}, {
					label: '女',
					value: 0,
				}],
				codeList: '',

				formDataList: {
					data1: {
						index: 1, // 索引
						InsuredName: '', //被保人姓名
						InsuredPing: '', //被保人拼音
						InsuredType: '', //被保人证件类型
						InsuredIdCard: '', //被保人身份证号码
						InsuredIdCard2: '', // 被保人护照号码
						InsuredSex: '', //被保人性别
						InsuredBirthday: '', //被保人出生日期
					}
				},

				expireTimeOPtion: {
					disabledDate(time) {
						return time.getTime() < Date.now();
					}
				},

				expireTimeOPtion2: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					}
				},

				endTime: '',
				endTimeEen: '',
			};
		},
		created() {
			let {
				productId,
				RateCode,
				PlanRatePriceId,
				price,
				tian
			} = this.$route.query
			this.productId = productId
			this.RateCode = RateCode
			this.PlanRatePriceId = PlanRatePriceId
			this.price = price
			this.tian = tian
			this.ProductDetail(productId)
		},

		methods: {
			// 计算终保时间
			getEndTime(value) {
				let changeTime = (val) => {
					if (val < 10) {
						return '0' + val
					} else {
						return val
					}
				}
				let endDate = ''
				if (this.form.DayRange.indexOf('年') == -1 && this.form.DayRange != '1天') {
					let a = this.form.DayRange.split('-')[1].split('天')
					endDate = new Date(value + 3600 * 1000 * (a[0] - 1) * 24)
				} else if (this.form.DayRange == '1天') {
					endDate = new Date(value)
				} else {
					if (this.form.DayRange.indexOf('183') != -1) {
						endDate = new Date(value + 3600 * 1000 * 182 * 24)
					} else {
						endDate = new Date(value + 3600 * 1000 * 364 * 24)
					}
				}
				this.endTime = `${endDate.getFullYear()}年${endDate.getMonth() + 1}月${endDate.getDate()}日 23:59:59`;
				this.endTimeEen =
					`${endDate.getFullYear()}-${changeTime(endDate.getMonth() + 1)}-${changeTime(endDate.getDate())} 23:59:59`;
			},
			

			submit() {
				const that = this;
				if (!this.checked) return this.$message({
					message: '请阅读并同意《保险条款》和《投保人申明》',
					type: 'warning'
				});

				let {
					formDataList,
					form,
					RateCode,
					PlanRatePriceId,
					productId,
					price
				} = that;

				// 被保人校验
				let x = true
				for (let key in this.formDataList) {
					let ref = eval('that.$refs.listRef' + key)[0]
					ref.validate(res => {
						console.log(res, ref, 'that.$refs.listRef' + key)
						if (!res) {
							x = false
						}
					})
				}
				
				// 投保人校验
				that.$refs.infoRef.validate((Res) => {
					if (Res && x) {
						console.log('通过');

						let InsureArr = [];
						Object.keys(formDataList).forEach((item, index, name) => {
							let obj = {
								id: formDataList[item].id ? formDataList[item].id : '',
								CName: formDataList[item].InsuredName,
								EName: formDataList[item].InsuredPing,
								CardType: formDataList[item].InsuredType,
								CardNo: formDataList[item].InsuredType == 1 ? formDataList[item]
									.InsuredIdCard : formDataList[item].InsuredIdCard2,
								Sex: formDataList[item].InsuredSex,
								BirthDay: formDataList[item].InsuredBirthday,
								Mobile: ''
							}
							InsureArr.push(obj)
						})

						this.getEndTime(new Date(form.currentDate).getTime())
						let parmens = {
							InsureType: form.applicant,
							RateCode: RateCode,
							PlanRatePriceId: PlanRatePriceId,
							ProductId: productId,
							MemberId: cookie.get('MemberId'),
							Email: form.email,
							Price: price,
							Destination: form.destination.join(';'),

							StartTime: form.currentDate,
							EndTime: this.endTimeEen,

							CName: form.applicant == 1 ? '' : form.enterpriseName,
							EName: form.applicant == 1 ? '' : form.enterprisePing,
							CardType: form.applicant == 1 ? '' : 4,
							CardNo: form.applicant == 1 ? '' : form.enterpriseNumber,
							Mobile: form.applicant == 1 ? '' : form.enterprisePhone,
							Detail: InsureArr,
							Id: form.orderId ? orderId : '',
						}

						// that.$router.push('/InsuranceDetail?order=43913e3581bb4993a4d08036ed1f7a4e')
						that.$api.InsuranceOrder(parmens).then(res => {
							console.log(res)
							let {
								data,
								status
							} = res.data
							if (status == 200) {
								that.$message({
									message: res.data.message,
									type: 'success'
								})
								that.$router.push('/InsuranceDetail?order=' + data.Id)
							} else {
								that.$message({
									message: res.data.message,
									type: 'error'
								})
							}
						}).catch(err => {
							that.$message({
								message: res.data.message,
								type: 'error'
							})
							console.log(err)
						})
					}
				})
			},



			checkEmail(rule, value, callback) {
				const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
				emailRegex.test(value) ? callback() : callback(new Error("邮箱格式错误"))
			},

			checkPhone(rule, value, callback) {
				const emailRegex = /^1[3456789]\d{9}$/;
				emailRegex.test(value) ? callback() : callback(new Error("手机格式错误"))
			},

			checkProv(val) {
				var pattern = /^[1-9][0-9]/;
				var provs = {
					11: "北京",
					12: "天津",
					13: "河北",
					14: "山西",
					15: "内蒙古",
					21: "辽宁",
					22: "吉林",
					23: "黑龙江 ",
					31: "上海",
					32: "江苏",
					33: "浙江",
					34: "安徽",
					35: "福建",
					36: "江西",
					37: "山东",
					41: "河南",
					42: "湖北 ",
					43: "湖南",
					44: "广东",
					45: "广西",
					46: "海南",
					50: "重庆",
					51: "四川",
					52: "贵州",
					53: "云南",
					54: "西藏 ",
					61: "陕西",
					62: "甘肃",
					63: "青海",
					64: "宁夏",
					65: "新疆",
					71: "台湾",
					81: "香港",
					82: "澳门"
				};
				if (pattern.test(val)) {
					if (provs[val]) {
						return true;
					}
				}
				return false;
			},

			checkDate(val) {
				var pattern = /^(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)$/;
				if (pattern.test(val)) {
					var year = val.substring(0, 4);
					var month = val.substring(4, 6);
					var date = val.substring(6, 8);
					var date2 = new Date(year + "-" + month + "-" + date);
					if (date2 && date2.getMonth() == (parseInt(month) - 1)) {
						return true;
					}
				}
				return false;
			},

			checkCode(val) {
				var p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
				var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
				var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
				var code = val.substring(17);
				if (p.test(val)) {
					var sum = 0;
					for (var i = 0; i < 17; i++) {
						sum += val[i] * factor[i];
					}
					if (parity[sum % 11] == code.toUpperCase()) {
						return true;
					}
				}
				return false;
			},

			focus(index) {
				this.activeIndex = index
			},
			
			CardInput(value){
				this.formDataList[this.activeIndex].InsuredIdCard = value
				this.formDataList[this.activeIndex].InsuredIdCard2 = value
			},

			checkID(rule, value, callback) {
				console.log(rule)

				if (this.checkCode(value)) {
					var date = value.substring(6, 14);
					if (this.checkDate(date)) {
						if (this.checkProv(value.substring(0, 2))) {
							callback()
						}
					}
				}
				callback('身份证号格式错误')

				// if (this.formDataList[this.activeIndex].InsuredType == 1) {

				// } else {
				// 	callback()
				// }

			},


			blurInput(e, index = null) {
				let {
					name,
					value
				} = e.target
				// 转拼音
				if (name == 'enterpriseName') {
					this.form.enterprisePing = util.ConvertPinyin(value)
				} else if (name == 'InsuredName') {
					this.formDataList[index].InsuredPing = util.ConvertPinyin(value)
				}
			},


			// 产品详情
			ProductDetail(id) {
				this.$api.ProductDetail({
					productId: id
				}).then(res => {
					let {
						status,
						data
					} = res.data
					if (status == 200) {
						console.log(data)
						this.data = data
						this.getDay(data.planList)
						this.getStateList(data.countryList)
					}
				})
			},

			// 获取天数范围
			getDay(data) {
				let that = this;
				let DayRangeList = [];
				let codeList = [];
				for (let i = 0; i < data.length; i++) {
					for (let x = 0; x < data[i].rateList.length; x++) {
						for (let y = 0; y < data[i].rateList[x].planRatePriceList.length; y++) {
							let key = data[i].rateList[x].planRatePriceList[y].DayRange
							if (that.RateCode == data[i].rateList[x].planRatePriceList[y].RateCode) {
								for (let u = 0; u < data[i].rateList[x].planRatePriceList.length; u++) {
									if (codeList.RateCode == data[i].rateList[x].planRatePriceList[u].RateCode) {
										break;
									}
									let code = {
										RateCode: data[i].rateList[x].planRatePriceList[u].RateCode,
										Id: data[i].rateList[x].planRatePriceList[u].Id,
										DayRange: data[i].rateList[x].planRatePriceList[u].DayRange
									}
								}
							}

							if (!DayRangeList.length) {
								DayRangeList.push(key)
							} else {
								var _r_ = 1
								for (let r = 0; r < DayRangeList.length; r++) {
									if (DayRangeList[r] == data[i].rateList[x].planRatePriceList[y].DayRange) {
										_r_ += 1
										break;
									}
								}
								if (_r_ == 1) {
									DayRangeList.push(key)
									_r_ = 1
								}
							}
						}
					}
				}

				that.form.DayRange = that.tian ? that.tian : DayRangeList[0],
					that.columns4 = DayRangeList,
					that.codeList = codeList
			},

			// 国家列表
			getStateList(data) {
				let StateList = []
				for (let i = 0; i < data.length; i++) {
					StateList.push(data[i].zh_name)
				}
				console.log(StateList)
				this.columns2 = StateList
			},

			// 添加被投人
			addInsuredForm() {
				let that = this
				// let list = this.formDataList
				let obj = {
					index: Object.keys(this.formDataList).length + 1, // 索引
					InsuredName: '', //被保人姓名
					InsuredPing: '', //被保人拼音
					InsuredType: '', //被保人证件类型
					InsuredIdCard: '', //被保人证件号码
					InsuredIdCard2: '',
					InsuredSex: '', //被保人性别
					InsuredBirthday: '', //被保人出生日期
				}
				this.$set(this.formDataList, 'data' + Number(Object.keys(this.formDataList).length + 1), obj)
			},

		}
	}
</script>

<style lang='less' scoped>
	.page {
		min-height: 100vh;

		&>div {
			width: 75rem;
			margin: 1.25rem auto;
			min-height: 35rem;
			display: flex;
			justify-content: space-between;

			.main_left {
				width: 18.5rem;
				height: 19rem;
				padding: 1.25rem;
				background-color: #fff;
				text-align: left;

				&>p {
					font-size: 1.25rem;
					font-weight: 600;
					margin: 1rem 0;
				}

				.main_left_info {
					width: 100%;
					height: 7.8125rem;
					background-color: #fafbfc;
					display: flex;
					flex-direction: column;
					justify-content: space-around;

					&>div {
						padding: 0 1rem;
						display: flex;
						justify-content: space-between;
					}
				}

				.main_left_price {
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin-top: 1.25rem;

					&>p:nth-child(1) {
						margin-left: 1.25rem;
					}

					&>p:nth-child(2) {
						display: flex;
						align-items: center;
						font-size: 1.125rem;
						color: #ff8033;

						&>span {
							font-size: 1.875rem;
							font-weight: 600;
						}
					}
				}
			}

			.main_right {
				width: 50.1875rem;
				padding: 1.25rem 1.25rem 2.25rem;
				min-height: 50.25rem;
				background-color: #fff;

				.info {
					margin-top: 2rem;
					margin-bottom: 1.25rem;

					.item_label {
						font-size: 1rem;

						&>span:nth-child(1) {
							color: #F56C6C;
							margin-right: 0.25rem;
						}

						&>span:nth-child(2) {
							color: #999;
							font-size: 0.75rem;
						}
					}

					.el-form {
						text-align: left;
					}

					/deep/.el-form-item__label {
						font-size: 1rem;
						padding: 0;
					}

					.info_tiele {
						font-size: 1.25rem;
						font-weight: 600;
						float: left;
						position: relative;
						display: inline-block;
						z-index: 10;
					}

					.info_tiele:before {
						content: "";
						display: block;
						width: 100%;
						background: linear-gradient(90deg, rgba(90, 153, 255, 1.0), rgba(255, 255, 255, .5));
						height: 0.375rem;
						position: absolute;
						bottom: 0;
						z-index: -1;
						border-radius: 12px;
					}

					.tabs_head {
						width: 100%;
						height: 3.75rem;
						background-color: #fafbfc;
						border: 1px solid #eee;
						display: flex;
						align-items: center;
						text-align: center;
						font-size: 0.875rem;

						&>div {
							margin-left: 0.425rem;
						}

						&>div:nth-child(1) {
							width: 7.125rem;
						}

						&>div:nth-child(2) {
							width: 6.375rem;
						}

						&>div:nth-child(3) {
							width: 6.075rem;
						}

						&>div:nth-child(4) {
							width: 13.0rem;
						}

						&>div:nth-child(5) {
							width: 6.3125rem;
						}

						&>div:nth-child(6) {
							width: 7.8125rem;
						}
					}

					.list_item {
						width: 100%;
						height: 4.975rem;
						display: flex;
						align-items: center;
						border-bottom: 1px solid #eee;

						.el-form {
							width: 100%;
							display: flex;
							align-items: center;

							/deep/.el-date-editor--date {
								.el-input__inner {
									padding-right: 0 !important;
								}
							}

							&>div {
								height: 2.5rem;
								margin-right: 0.625rem;
							}

							&>div:nth-child(2) {
								width: 6.125rem;
							}

							&>div:nth-child(3) {
								width: 6.375rem;
							}

							&>div:nth-child(4) {
								width: 6.375rem;
							}

							&>div:nth-child(5) {
								width: 13.5rem;
							}

							&>div:nth-child(6) {
								width: 6.3125rem;
							}

							&>div:nth-child(7) {
								width: 8.0625rem;
							}
						}

					}

					.btn_box {
						width: 100%;
						margin-top: 1.25rem;
						position: relative;

						.add_insured {
							position: absolute;
							left: 50%;
							transform: translate(-50%, 0%);
						}
					}

					.footer {
						width: 100%;
						display: flex;
						align-items: center;
						justify-content: space-between;
						margin-top: 6.875rem;
						font-size: 0.875rem;

						/deep/ .el-button {
							padding: 0.625rem 2.875rem;
							background-color: #599fff;
						}

						span {
							color: #599fff;

						}
					}
				}

			}
		}

		.dialog_box {
			height: 100%;

			p {
				text-align: left;
				font-size: 0.875rem;
			}
		}
		
		.dialog_box::-webkit-scrollbar{
			width: 0 !important;
		}

		.dialog-footer {
			text-align: center;
			margin: 0 auto;

			/deep/ .el-button {
				padding: 0.625rem 2.875rem;
				background-color: #599fff;
			}
		}

		/deep/.el-dialog__footer {
			text-align: center;
		}

		/deep/.el-dialog {
			height: 100%;
			margin-top: 0vh !important;
		}
	}
</style>



// WEBPACK FOOTER //
// src/page/Insurance/form.vue